import React from "react";

export const ArtistIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M4 20c0-4 4-6 8-6s8 2 8 6"/>
    </svg>
);

export const AgentIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="7" width="18" height="13" rx="2"/>
        <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2"/>
        <path d="M12 12v4"/>
        <path d="M3 12h18"/>
    </svg>
);

export const VenueIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18"/>
        <path d="M5 21V7l7-4 7 4v14"/>
        <path d="M9 21v-6h6v6"/>
        <path d="M9 9h.01"/>
        <path d="M15 9h.01"/>
        <path d="M9 12h.01"/>
        <path d="M15 12h.01"/>
    </svg>
);

export const PartiesIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 00-3-3.87"/>
        <path d="M4 21v-2a4 4 0 013-3.87"/>
        <circle cx="12" cy="7" r="4"/>
        <path d="M16 3.13a4 4 0 010 7.75"/>
        <path d="M8 3.13a4 4 0 000 7.75"/>
    </svg>
);

export const BandIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="9" cy="7" r="3"/>
        <circle cx="15" cy="7" r="3"/>
        <path d="M12 14c-4 0-7 2-7 4v2h14v-2c0-2-3-4-7-4z"/>
    </svg>
);

export const SoloIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="8" r="4"/>
        <path d="M6 20c0-3.5 3-5.5 6-5.5s6 2 6 5.5"/>
        <path d="M12 12v8"/>
    </svg>
);

export const InvitationIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="4" width="20" height="16" rx="2"/>
        <path d="M22 6l-10 7L2 6"/>
    </svg>
);

export const CheckIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
);

export const CheckmarkIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
);

export const WarningIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 9v4m0 4h.01M12 3l9.5 16.5H2.5L12 3z"/>
    </svg>
);

export const InfoIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <path d="M12 16v-4"/>
        <path d="M12 8h.01"/>
    </svg>
);

export const SingleVenueIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 21h18"/>
        <path d="M5 21V7l7-4 7 4v14"/>
        <path d="M9 21v-6h6v6"/>
        <path d="M9 9h.01"/>
        <path d="M15 9h.01"/>
        <path d="M9 12h.01"/>
        <path d="M15 12h.01"/>
    </svg>
);

export const VenueGroupIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 21h6"/>
        <path d="M4 21V11l3-2 3 2v10"/>
        <path d="M16 21h6"/>
        <path d="M18 21V11l3-2 3 2v10"/>
        <path d="M9 21h6"/>
        <path d="M11 21V7l3-2 3 2v14"/>
        <path d="M5 14h.01"/>
        <path d="M5 17h.01"/>
        <path d="M12 11h.01"/>
        <path d="M12 14h.01"/>
        <path d="M12 17h.01"/>
        <path d="M19 14h.01"/>
        <path d="M19 17h.01"/>
    </svg>
);
